module.exports = __webpack_public_path__ + "media/images/minec-4969a9f06437dc9df55151bc928fa045.png";